// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 9844); hand-edits allowed (see docs/architecture.md)

/** `this.ACHIEV_RATING_BONUS` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_ACHIEV_RATING_BONUS(): any {
  return [0, 200, 400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2500, 3000, 3500, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 12000, 14000, 16000, 18000, 20000, 24000, 28000, 32000, 36000, 40000, 50000, 60000, 70000, 80000, 100000, 120000];
}
